/**
 * Map CMS pageKey / sectionKey เป็นภาษาลาวที่อ่านได้ (แสดงใน UI)
 */

const PAGE_KEY_LABELS: Record<string, string> = {
  home: "ຫນ້າຫຼັກ",
  about: "ກ່ຽວກັບ",
  global: "ທົ່ວໄປ",
};

/** ລາຍການ page key ສຳລັບ Select (ຫນ້າທີ່ມີ sections) */
export const CMS_PAGE_KEY_OPTIONS = [
  { value: "home", label: PAGE_KEY_LABELS.home },
  { value: "about", label: PAGE_KEY_LABELS.about },
  { value: "global", label: PAGE_KEY_LABELS.global },
] as const;

const SECTION_KEY_LABELS: Record<string, string> = {
  "home.hero": "Hero ຫນ້າຫຼັກ",
  "home.content": "ບລ໋ອກສິນຄ້າ",
  "global.banner": "ແບນເນີ",
  "global.footer": "ສ່ວນທ້າຍ",
  "global.privacy": "ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ",
  "global.terms": "ຂໍ້ຕົກລົງການບໍລິການ",
  "about.hero": "Hero ກ່ຽວກັບ",
  "about.story": "ເລື່ອງລາວ",
  "about.vision": "ວິໄສທັດ",
  "about.mission": "ພາລະກິດ",
  "about.core-value": "ຄຸນຄ່າຫຼັກ",
  "about.team": "ທີມງານ",
  "about.services": "ບໍລິການ",
  "about.partner": "ຄູ່ຮ່ວມງານ",
  "about.gallery": "ຄັງຮູບ",
  "about.contact": "ຕິດຕໍ່",
};

/** คืน label ພາສາລາວສຳລັບ pageKey, ຖ້າບໍ່ມີໃຊ້ key ເອງ */
export function getPageKeyLabel(pageKey: string): string {
  return PAGE_KEY_LABELS[pageKey] ?? pageKey;
}

/** คืน label ພາສາລາວສຳລັບ sectionKey, ຖ້າບໍ່ມີໃຊ້ key ເອງ */
export function getSectionKeyLabel(sectionKey: string): string {
  return SECTION_KEY_LABELS[sectionKey] ?? sectionKey;
}
